export const GTM_EVENTS = {
  RENT_ZESTIMATE: 'RentZestimate',
  RENTAL_MANAGER_ADD_PROPERTY: 'RentalManager::AddProperty',
};
